module.exports = __webpack_public_path__ + "img/bg.28182d15.jpg";